import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-9.svg";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";

/** Bandeau d'appel à l'action violet (même construction que cta/GetStarted du template). */

const Band = tw.div`py-16 lg:py-20 bg-primary-500 rounded-lg relative overflow-hidden`;
const Row = tw.div`px-8 max-w-screen-lg mx-auto flex items-center relative z-10 flex-col lg:flex-row text-center lg:text-left`;
const TextContainer = tw.div`lg:w-3/5 max-w-lg`;
const Title = tw.h2`text-gray-100 text-2xl sm:text-3xl font-bold leading-snug`;
const Text = tw.p`mt-3 text-gray-100 text-sm sm:text-base font-medium opacity-75 leading-relaxed`;
const Links = tw.div`lg:w-2/5 flex justify-center lg:justify-end mt-8 lg:mt-0 flex-col sm:flex-row`;
const ButtonBase = styled(Link)`
  ${tw`w-full sm:w-auto text-sm sm:text-base px-6 py-3 sm:px-8 sm:py-4 mt-4 first:mt-0 sm:mt-0 sm:mr-4 sm:last:mr-0 rounded-full font-bold border border-transparent tracking-wide transition duration-300 focus:outline-none focus:shadow-outline text-center`}
`;
const PrimaryLink = tw(ButtonBase)`bg-gray-100 text-primary-500 shadow-lg hocus:bg-gray-300 hocus:text-primary-700`;
const SecondaryLink = tw(ButtonBase)`text-gray-100 border-gray-100 hocus:bg-gray-100 hocus:text-primary-500`;
const DecoratorBlobContainer = tw.div`absolute inset-0 overflow-hidden rounded-lg`;
const DecoratorBlob1 = tw(SvgDecoratorBlob1)`absolute bottom-0 left-0 w-80 h-80 transform -translate-x-20 translate-y-32 text-primary-700 opacity-50`;
const DecoratorBlob2 = tw(SvgDecoratorBlob1)`absolute top-0 right-0 w-80 h-80 transform translate-x-20 -translate-y-64 text-primary-700 opacity-50`;

export default function BlogCta({
  heading = "Un sujet tech à faire connaître à Besançon ? Une innovation à raconter ?",
  text = "Startups, laboratoires, collectivités, écoles : parlez-nous de ce qui bouge chez vous. Le journal est à but non lucratif : nous relayons par passion, gratuitement et sans contrepartie.",
  primaryText = "Nous contacter",
  primaryTo = "/contact",
  secondaryText = "Qui sommes-nous ?",
  secondaryTo = "/about",
}) {
  return (
    <Container>
      <ContentWithPaddingXl>
        <Band>
          <Row>
            <TextContainer>
              <Title>{heading}</Title>
              {text && <Text>{text}</Text>}
            </TextContainer>
            <Links>
              <PrimaryLink to={primaryTo}>{primaryText}</PrimaryLink>
              {secondaryText && <SecondaryLink to={secondaryTo}>{secondaryText}</SecondaryLink>}
            </Links>
          </Row>
          <DecoratorBlobContainer aria-hidden="true">
            <DecoratorBlob1 />
            <DecoratorBlob2 />
          </DecoratorBlobContainer>
        </Band>
      </ContentWithPaddingXl>
    </Container>
  );
}
